const env = process.env.NODE_ENV
const isTest = env === 'test'

module.exports = {
	error: (err) => !isTest && console.error(err),
	log: (msg) => !isTest && console.log(msg),
	warn: (w) => !isTest && console.warn(w),
}


// WEBPACK FOOTER //
// ./src/server/lib/logger.js